export enum VisualArtCategory {
    VisualArts = 'Visual Arts',
}

export enum VisualArtEmailType {
    performanceAwaitingApproval = 0,
    performanceApproved = 1,
    performancePaymentAdded = 2,
    performancePaymentConfirmed = 3,
    performanceFileUploaded = 4,
    performanceSubmissionCompleted = 5,
    performanceReviewSubmitted = 6
}

export enum VisualArtStatus {
    ProjectReviewRequired = 'Lyrics Review Required',
    SubmissionFailed = 'Submission Failed',

    // Cannot submit without uploaded file / url
    PendingCoordinatorApproval = 'Pending Coordinator Approval',
    PendingPayment = 'Pending Payment',
    PendingProject = 'Pending Project',
    PendingReview = 'Pending Review',
    SubmissionCompleted = 'Submission Completed'
}
